/**
 * Retailer has seen the PREPAID_CARDS_RESTRICTED_MODAL promo modal *
 * @deprecated
 */ export var PREPAID_CARDS_RESTRICTED_MODAL_SEEN = 'PREPAID_CARDS_RESTRICTED_MODAL_SEEN';
